import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-empty-table',
  templateUrl: './empty-table.component.html',
  styleUrls: ['./empty-table.component.scss'],
})
export class EmptyTableComponent {
  @Input() labelValue: string;
  @Input() topOffset = 200; // px
  @Input() icon: string = 'transactions-empty';

  constructor() {
  }

}
